
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  effect,
  forwardRef,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@softline/core';
import { I18nModule } from '../../../i18n/i18n.module';
import { SOFTLINE_FEATURE_MODAL } from '../../../modal/legacy/modal.shared';
import * as ModalStore from '../../../modal/legacy/modal.store';
import { IconComponent } from '../../icon/icon.component';
import { SelectBoxOptionDirective } from './select-box-option.directive';

@Component({
  selector: 'soft-select-box',
  imports: [IconComponent, I18nModule],
  templateUrl: './select-box.component.html',
  styleUrl: './select-box.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectBoxComponent),
      multi: true,
    },
  ],
})
export class SelectBoxComponent {
  private onChange: Function = () => {};
  private onTouch: Function = () => {};

  store = inject(Store);
  icon = input<string | undefined>();
  title = input.required<string>();
  options = contentChildren(SelectBoxOptionDirective);

  readonly = input<boolean>(false, { alias: 'readonly' });

  inputValue = input<any>(null, { alias: 'value' });
  value = signal<any>(null);
  valueChange = output<any>();

  option = computed(() => {
    const value = this.value();
    return this.options().find(
      (option: SelectBoxOptionDirective) => option.value === value
    );
  });

  inputValueEffect = effect(() => {
    this.value.set(this.inputValue());
  });

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  async onClick(): Promise<void> {
    const result = await this.store.dispatch(
      SOFTLINE_FEATURE_MODAL,
      ModalStore.actions.choose(),
      {
        title: this.title(),
        options: this.options().map((o) => o),
        dismiss: true,
      }
    );
    if (result === 'DISMISSED') return;
    this.value.set(result);
    this.valueChange.emit(result);
  }
}
